const grey = {
  800: '#1A1A1A',
  700: '#535353',
  600: '#817F7D',
  500: '#ABA8A4',
  400: '#D7D4D1',
  300: '#E5E4E3',
  200: '#F2F2F2',
  100: '#F9F9F9',
};

const violet = {
  600: '#6672FF',
  500: '#969EFF',
  400: '#C0C8FF',
  300: '#D9DEFF',
  200: '#E5E9FF',
  100: '#F5F6FF',
};

declare module '@mui/material/styles' {
  interface SimplePaletteColorOptions {
    lighter: string;
    darker: string;
  }
  interface PaletteColor {
    lighter: string;
    darker: string;
  }
}

const PRIMARY = {
  lighter: '#ABA8A4',
  light: '#818078',
  main: '#363634',
  dark: '#818078',
  darker: '#818078',
};

const SECONDARY = {
  lighter: violet['400'],
  light: violet['400'],
  main: violet['600'],
  dark: violet['500'],
  darker: violet['500'],
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
};
const SUCCESS = {
  lighter: '#B2DFDB',
  light: '#80CBC4',
  main: '#00B09F',
  dark: '#059183',
  darker: '#046B61',
};
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
};
const ERROR = {
  lighter: '#FFC7C2',
  light: '#FF918C',
  main: '#F96766',
  dark: '#B72136',
  darker: '#7A0C2E',
};

const COMMON = {
  common: { black: '#000', white: '#fff', violet },
  primary: { ...PRIMARY, contrastText: '#fff' },
  secondary: { ...SECONDARY, contrastText: '#fff' },
  info: { ...INFO, contrastText: '#fff' },
  success: { ...SUCCESS, contrastText: grey[800] },
  warning: { ...WARNING, contrastText: grey[800] },
  error: { ...ERROR, contrastText: '#fff' },
  grey,
  divider: grey[300],
  action: {
    hover: grey[100],
    selected: grey[200],
    disabled: grey[400],
    disabledBackground: grey[300],
    focus: grey[300],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
  filters: {
    background: '#f9f9f9',
  },
};

export const MUIPalette = {
  ...COMMON,
  text: { primary: grey[800], secondary: grey[600], disabled: grey[500] },
  background: { paper: 'white', default: 'white', neutral: grey[200] },
  action: { active: grey[600], ...COMMON.action },
};
